<template>
  <div v-if="visible" class="image-preview-overlay" @click.self="close">
    <div class="image-preview-container">
      <button class="image-preview-close" @click="close">×</button>
      <div class="image-preview-content">
        <img 
          :src="imageUrl" 
          class="preview-image" 
          alt="Full size preview"
          @error="handleImageError"
          @load="handleImageLoad"
        />
        <div v-if="imageError" class="image-error-message">
          <i class="fas fa-exclamation-triangle"></i>
          <p>Failed to load image. The file may be missing or inaccessible.</p>
          <button @click="openInNewTab" class="error-btn">Open in New Tab</button>
        </div>
        <div class="image-preview-controls" v-if="!imageError">
          <button @click="downloadImage" class="preview-btn">
            <i class="fas fa-download"></i> Download
          </button>
          <button @click="openInNewTab" class="preview-btn">
            <i class="fas fa-external-link-alt"></i> Open in New Tab
          </button>
          <button @click="copyImageUrl" class="preview-btn">
            <i class="fas fa-copy"></i> Copy URL
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    visible: { type: Boolean, default: false },
    imageUrl: { type: String, default: '' }
  },
  data() {
    return {
      imageError: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.imageError = false;
        document.body.style.overflow = 'hidden';
        console.log('ImageModal opened with URL:', this.imageUrl);
      } else {
        document.body.style.overflow = '';
      }
    },
    imageUrl() {
      this.imageError = false;
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleImageError() {
      this.imageError = true;
      console.error('Failed to load image:', this.imageUrl);
    },
    handleImageLoad() {
      console.log('Image loaded successfully:', this.imageUrl);
    },
    downloadImage() {
      const link = document.createElement('a');
      link.href = this.imageUrl;
      link.download = this.imageUrl.split('/').pop() || 'image.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openInNewTab() {
      window.open(this.imageUrl, '_blank');
    },
    async copyImageUrl() {
      try {
        await navigator.clipboard.writeText(this.imageUrl);
        alert('Image URL copied to clipboard!');
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  }
}
</script>

<style scoped>
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  cursor: pointer;
}

.image-preview-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
}

.image-preview-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.preview-image {
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.image-preview-close {
  position: absolute;
  top: -50px;
  right: 0;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 32px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10;
}

.image-preview-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.image-preview-controls {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.preview-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.image-error-message {
  text-align: center;
  color: #ef4444;
  padding: 40px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 12px;
}

.image-error-message i {
  font-size: 48px;
  margin-bottom: 16px;
}

.error-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 16px;
}

.error-btn:hover {
  background: #dc2626;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/ImageModal.vue